export enum ETipoMovimentoEstoque {
    Todos = 0,
    Entrada = 1,
    Saida = 2,
    Bloqueio = 3,
    Liberacao = 4
}
